export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.isOpenAdd = payload.isDisplay;
  newState.isDisplaySetting = payload.isDisplaySetting;
  newState.dataBlock = payload.dataBlock;
  newState.index = payload.index;

  return newState;
};
